module.exports = __webpack_public_path__ + "static/media/Mask.44128c73.PNG";